import { gql } from '@apollo/client';

export default gql`
  mutation acceptSpaceInvitation($spaceId: ID!) {
    acceptSpaceInvitation(input: { spaceId: $spaceId }) {
      success
      spaceId
    }
  }
`;
